import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { StoreClosedScreen } from './StoreClosedScreen';

export const GlobalStoreLoader = ({ children }: { children: React.ReactNode }) => {
  const [status, setStatus] = useState<'loading' | 'ready' | 'closed'>('loading');

  const checkConnection = async () => {
    try {
      setStatus('loading');
      
      const isLocal = window.location.hostname === 'localhost' || 
                      window.location.hostname === '127.0.0.1' || 
                      window.location.hostname.startsWith('192.168.');
      
      if (isLocal) {
        setStatus('ready');
        return;
      }

      // Preguntar a Hostinger cuál es el Ngrok URL de hoy
      const res = await axios.get('/dynamic_api.php?t=' + Date.now(), { timeout: 5000 });
      const dynamicUrl = res.data?.data?.url;

      // Si Hostinger no tiene un URL registrado
      if (!dynamicUrl) {
        setStatus('closed');
        return;
      }

      // Guardar el URL para Axios y las imágenes
      const apiUrl = `${dynamicUrl}/api`;
      localStorage.setItem('dynamicApiUrl', apiUrl);

      // Hacer ping rápido a Ngrok para ver si el túnel y el PC local están realmente prendidos
      await axios.get(`${apiUrl}/categories`, {
        headers: { 'ngrok-skip-browser-warning': '1' },
        timeout: 5000
      });

      setStatus('ready');
    } catch (err) {
      console.error('El túnel o la conexión fallaron:', err);
      setStatus('closed');
    }
  };

  useEffect(() => {
    checkConnection();
  }, []);

  if (status === 'loading') {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50 dark:bg-slate-900">
        <div className="flex flex-col items-center">
          <div className="w-12 h-12 border-4 border-pink-200 border-t-pink-500 rounded-full animate-spin mb-4"></div>
          <p className="text-slate-600 dark:text-slate-400 font-medium">Conectando con la tienda...</p>
        </div>
      </div>
    );
  }

  if (status === 'closed') {
    return <StoreClosedScreen onRetry={checkConnection} />;
  }
  
  return <>{children}</>;
};
